export default __webpack_public_path__ + "static/media/curation-after.30f9bfed.jpg";